import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {BrowserRouter as Router, Switch} from 'react-router-dom';
import store from './store';
import {SessionConfiguration, Theme} from '@castiron/components';
import './index.css';
import App from './components/App/App';
import Error from './components/Error';
import {Configuration, FirebaseApp, FirebaseContext} from '@castiron/castiron-firebase';
import firebase from 'firebase/compat/app';
import {AttributionConfig} from "@castiron/utils";
import FeatureConfiguration from "./components/FeatureConfiguration";
import StripeElementsProvider from "./components/StripeElementsProvider";
import CelloReferralConfiguration from "./components/CelloReferralConfiguration";
import {sessionRepository} from "./domain";
import {MarketplaceIdentifier} from "@castiron/domain";

const marketplace = process.env.REACT_APP_MARKETPLACE_ID as (MarketplaceIdentifier | 'all');

if (process.env.REACT_APP_IS_LOCAL_FIREBASE == 'true') {
  console.warn('Local Environment Detected, pointing Firebase to local emulators.');
  FirebaseApp.functions().useEmulator('localhost', 5001);
  FirebaseApp.firestore().useEmulator('localhost', 6001);
  FirebaseApp.storage().useEmulator('localhost', 9199);
  FirebaseApp.auth().useEmulator('http://localhost:9099');
}

// @ts-ignore
const remoteConfig = firebase.remoteConfig(FirebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis = 15000;

const error = <Error/>;

const urlParams = new URLSearchParams(window.location.search);

ReactDOM.render(
    <FirebaseContext.Provider value={FirebaseApp}>
      <AttributionConfig gaStreamId={process.env.REACT_APP_GA_MEASUREMENT_ID} marketplaceId={marketplace}>
        <SessionConfiguration sessionManager={{
          create: s => sessionRepository.create(s),
          update: s => sessionRepository.update(s),
          get: id => sessionRepository.get(id)
        }} sid={urlParams.get('sid')}>
          <Provider store={store}>
            <FeatureConfiguration>
              <Configuration remoteConfig={remoteConfig}>
                <CelloReferralConfiguration>
                  <StripeElementsProvider>
                    <Theme>
                      <Router>
                        <Switch>
                          <App/>
                        </Switch>
                      </Router>
                    </Theme>
                  </StripeElementsProvider>
                </CelloReferralConfiguration>
              </Configuration>
            </FeatureConfiguration>
          </Provider>
        </SessionConfiguration>
      </AttributionConfig>
    </FirebaseContext.Provider>,
  document.getElementById('root'),
);
